// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:37
import { SagaObject } from '../../SagaBase/SagaObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class MobilePosition_abstract extends SagaObject {
  static $t: string = 'SagaBase.MobilePosition';
  $t: string = 'SagaBase.MobilePosition';

  public static GetMembers(): string[] {
    return ['PositionUid', 'Name', 'CoordX', 'CoordY', 'CallcardUid', 'PositionProvider', 'ResourceUid'].concat(SagaObject.GetMembers());
  }

  public GetMembers(): string[] {
    return MobilePosition_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public PositionUid: Guid = GuidTools.Empty;
  public Name: string;
  public CoordX: number = 0;
  public CoordY: number = 0;
  public CallcardUid: string;
  public PositionProvider: boolean = false;
  public ResourceUid: Guid = GuidTools.Empty;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.PositionUid;
  }
  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
